window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.followUsBox = window.locales.am.followUsBox || {};window.locales.am.followUsBox = {...window.locales.am.followUsBox, ...{
    "heading": "{institutionName} ን ተከተል",
    "content": "በLinkedIn ገጻችን ላይ ተማሪዎችን፣ ዜናዎችን፣ ዝግጅቶችን እና የቀድሞ ተማሪዎችን ያግኙ።",
    "button_follow_us": "ተከተሉን።"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.followUsBox = window.locales.ar.followUsBox || {};window.locales.ar.followUsBox = {...window.locales.ar.followUsBox, ...{
    "heading": "تابع {institutionName}",
    "content": "ابحث عن الطلاب والأخبار والأحداث وقصص الخريجين على صفحتنا على LinkedIn.",
    "button_follow_us": "تابعنا"
}
};window.locales.en = window.locales.en || {};window.locales.en.followUsBox = window.locales.en.followUsBox || {};window.locales.en.followUsBox = {...window.locales.en.followUsBox, ...{
    "heading": "Follow {institutionName}",
    "content": "Find students, news, events, and alumni stories on our LinkedIn page.",
    "button_follow_us": "Follow Us"
}
};window.locales.es = window.locales.es || {};window.locales.es.followUsBox = window.locales.es.followUsBox || {};window.locales.es.followUsBox = {...window.locales.es.followUsBox, ...{
    "heading": "Seguir a {institutionName}",
    "content": "Encuentre estudiantes, noticias, eventos e historias de ex alumnos en nuestra página de LinkedIn.",
    "button_follow_us": "Síganos"
}
};window.locales.it = window.locales.it || {};window.locales.it.followUsBox = window.locales.it.followUsBox || {};window.locales.it.followUsBox = {...window.locales.it.followUsBox, ...{
    "heading": "Segui {institutionName}",
    "content": "Trova studenti, notizie, eventi e storie di ex studenti sulla nostra pagina LinkedIn.",
    "button_follow_us": "Seguici"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.followUsBox = window.locales.zh.followUsBox || {};window.locales.zh.followUsBox = {...window.locales.zh.followUsBox, ...{
    "heading": "关注{institutionName}",
    "content": "在我们的 LinkedIn 页面上查找学生、新闻、活动和校友故事。",
    "button_follow_us": "跟着我们"
}
};